import Rails from "@rails/ujs"
import { Controller } from "stimulus"

export default class extends Controller {
  static targets = ['form'];
  static classes = ['hide'];
  static values = {
    conveni: Boolean
  }

  connect() {
    this.control_show_and_hide();
    super.connect();
  }
  control_show_and_hide(){
    const delivery_to_shop = this.formTarget.querySelector("#prescription_delivery_to_shop")
    const pharmacy_information = this.formTarget.querySelector('#pharmacy_information_input_field')
    const medication_guidance = this.formTarget.querySelector('#medication_guidance_input_field')
    const send_address = this.formTarget.querySelector("#send_address_field");
    // const invoice_address = this.formTarget.querySelector("#invoice_address_field");
    if(delivery_to_shop.checked){
      pharmacy_information.classList.remove(this.hideClass);
      medication_guidance.classList.add(this.hideClass);
      if(!this.conveniValue){
        send_address.classList.add(this.hideClass);
      }
    } else {
      pharmacy_information.classList.add(this.hideClass);
      medication_guidance.classList.remove(this.hideClass);
      send_address.classList.remove(this.hideClass);

      const medication_guidance_tel = this.formTarget.querySelector('#prescription_medication_guidance_tel');
      const guidance_time = this.formTarget.querySelector('#guidance_time_input_field');

      if(medication_guidance_tel.checked){
        guidance_time.classList.remove(this.hideClass);
      }else{
        guidance_time.classList.add(this.hideClass);
      }
    }
  }

}
